import { render, staticRenderFns } from "./overdueStatus.vue?vue&type=template&id=aaa13e36&scoped=true&"
import script from "./overdueStatus.vue?vue&type=script&lang=js&"
export * from "./overdueStatus.vue?vue&type=script&lang=js&"
import style0 from "./overdueStatus.vue?vue&type=style&index=0&id=aaa13e36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa13e36",
  null
  
)

export default component.exports